/* Import Modules */
import $ from "jquery";
import { ref } from "vue";

/* Import Variables */
import {
  rentalContractEditForm,
  vueCanvasDrawingRef,
  isShow,
  isInsUpd,
} from "../variables";

import { automaticPageReload,automaticPageReloadStop, } from "../../compositions/script/pageReload";

/* Import Script */
import { getRentalContract } from "../axios/rentalContract/rentalContractGetAxios";
import { getGroupingDepartmentUserBySingle } from "../axios/user/GroupingDepartmentUserBySinglePulldownAxios";
import { getCarModel } from "../axios/carModel/carModelAxios";
import { getUsageObjectives } from "../axios/usageObjective/usageObjectiveAxios";
import { initializeErrors } from "../validation/validation";
import { setPreviewSignatureImage, getWidthSize } from "../script/canvas";

/* Define Variables. */
export const rentalContractModalRef = ref<any>(null);

import { errors } from "../validation/validation";

/* Define Functions. */
export const showRentalContractModal = async (scheduleId: number) => {
  getGroupingDepartmentUserBySingle();
  getCarModel();
  getUsageObjectives();
  await getRentalContract(scheduleId);
  await initializeErrors();

  await rentalContractModalRef.value?.showModal();
  // canvas
  vueCanvasDrawingRef.value?.redraw();
  // 手書き署名情報をcanvas部品で描画
  isShow.canvas = true;
  await setPreviewSignatureImage();
  getWidthSize();

  //戻るボタンで画面をリロードするかどうか
  isInsUpd.reload = false;

  automaticPageReloadStop();
};

export const hideRentalContractModal = () => {

    //登録または更新している場合、画面をリロードする
    if (isInsUpd.reload) {
        window.location.reload();
    } else {
        rentalContractModalRef.value?.hideModal();
        automaticPageReload();
    }
};
